"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateTags = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const create_tags_mutation_1 = require("./create-tags.mutation");
const useCreateTags = () => {
    const [createTagsMutation, data] = (0, react_2.useMutation)(create_tags_mutation_1.CREATE_TAGS);
    const createTags = (0, react_1.useCallback)((...args) => createTagsMutation(...args), [createTagsMutation]);
    return Object.assign({ createTags }, data);
};
exports.useCreateTags = useCreateTags;
exports.default = exports.useCreateTags;
